import React from 'react';
import './icon.scss';
import { IconProps } from '../../types/icons';

const CirclePlusIcon: React.FC<IconProps> = ({
  fill,
  color,
  width = 24,
  height,
  onClick,
  className,
}) => {
  const classBase = 'custom-icon';
  const classes = `${classBase} ${classBase}-color-${color} ${className || ''}`;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height || width}
      className={classes}
      fill={fill || '#7E8A96'}
      onClick={onClick}
      data-testid="circle-plus-icon"
      viewBox="0 0 21 20"
    >
      <path
        fill={fill || '#7E8A96'}
        fillRule="evenodd"
        d="M.5 10c0-5.523 4.477-10 10-10s10 4.477 10 10-4.477 10-10 10-10-4.477-10-10zm10-8a8 8 0 100 16 8 8 0 000-16z"
        clipRule="evenodd"
      />
      <path
        fill={fill || '#7E8A96'}
        fillRule="evenodd"
        d="M11.5 5a1 1 0 10-2 0v4h-4a1 1 0 000 2h4v4a1 1 0 102 0v-4h4a1 1 0 100-2h-4V5z"
        clipRule="evenodd"
      />
    </svg>
  );
};

export default CirclePlusIcon;
